import React from "react";
import { connect } from "react-redux";
import SimplifiedInterstitial from "./download-native-app";
import Library from "./index";
import { selectors as userSelectors } from "../../../redux/user";
import { showInterstitialScreen } from "../../utils/read-offline";
import { selectors as brandSelectors} from "../../../redux/brand"
import ConnectedRedirect from "../../../router/connected-redirect";

class LibraryOrDownloadApps extends React.Component {
  constructor() {
    super();
    this.state = {
      hasSkippedDownloadApps: false
    };
  }

  setHasSkippedDownloadApps() {
    this.setState({ hasSkippedDownloadApps: true });
  }

  renderComponent() {
    if (this.props.libraryRedirectURL) {
      return <ConnectedRedirect to={this.props.libraryRedirectURL} external sso={false}/>
    } else if (
      (this.props.isReferenceUser || this.props.isSsoSession) &&
      showInterstitialScreen()
    ) {
      if (!this.state.hasSkippedDownloadApps) {
        return (
          <SimplifiedInterstitial
            continueToMobileSite={() => this.setHasSkippedDownloadApps()}
          />
        );
      }
    }

    return <Library />;
  }

  render() {
    return this.renderComponent();
  }
}

const mapStateToProps = state => ({
  isReferenceUser: userSelectors.isReferenceUser(state),
  isSsoSession: userSelectors.isSsoSession(state),
  libraryRedirectURL: brandSelectors.getBrandValue(state, "Library.redirectURL", ""),
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryOrDownloadApps);
